import { request } from '../core';
import { CommonTableRequest, CommonTableResponse } from '@/components/CommonTable/type';

export enum VehicleOperationStateEnum {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface VehicleOperationStateItem {
  vehicleName: string;
  vehicleTypeTag?: string | null;
  stationId?: number | null;
  stationName?: string | null;
  operationState?: string | null;
  [key: string]: any;
}

export interface VehicleOperationStatePageRequest extends CommonTableRequest {
  vehicleName?: string | null;
  operationState?: string | null;
}

export type VehicleOperationStatePageResponse =
  CommonTableResponse<VehicleOperationStateItem>;

export interface VehicleOperationStateBatchRequest {
  vehicleNameList: string[];
  operationState: string;
}

export interface VehicleOperationStateBatchFailItem {
  vehicleName?: string;
  vehicleId?: string | number;
  reason?: string;
  message?: string;
  [key: string]: any;
}

export interface VehicleOperationStateBatchResult {
  successCount?: number;
  failCount?: number;
  resultDescription?: string;
  failList?: VehicleOperationStateBatchFailItem[];
  [key: string]: any;
}

export class VehicleOperationStateApi {
  getPageList(params: VehicleOperationStatePageRequest) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/vehicleOperation/page',
      body: params,
    };
    return request(options);
  }

  updateState(params: VehicleOperationStateBatchRequest) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/vehicleOperation/updateState',
      body: params,
    };
    return request(options);
  }
}
